import axios from 'axios'
const tok ='a5ec945de42672e03b563faa32f01a90'
const urlBase ='https://www.lefisc.com.br/api/CalculosTrabalhistas/calculos'
export default{
    getCnae(cnae){     
        return axios
        .post(`https://www.lefisc.com.br/api/RegimesTributarios/api/dados/79b71d0bd1868c4a0350dfabc4777f2e`,{"termo":cnae})
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCnaeRp(rp){     
        return axios
        .get(`https://www.lefisc.com.br/api/RegimesTributarios/api/rp/${rp}/79b71d0bd1868c4a0350dfabc4777f2e`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCalcularHoraExtra(mesAno,feriadosMes,salario,jornadaSemanal,adicional,check,quantidadeHorasExtras){
        
        // Se botar 20 fica "2000" e se botar 20,50 fica "2050"
        const valorConvertido = String(Math.round(parseFloat(String(quantidadeHorasExtras).replace(',', '.')) * 100));
        
        return axios
        .post(`${urlBase}/CalcularHoraExtra/${tok}`,{
            "mesAno":mesAno,
            "nFeriados":feriadosMes,
            "salario":salario,
            "jornadaSemanal":jornadaSemanal,
            "adicional":adicional,
            "dsr":check,
            "quantidadeHorasExtras":valorConvertido
        })
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCalcularCusto(obj){
        return axios
        .post(`${urlBase}/calcularCustoFuncionario/${tok}`,obj)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCalcularContrato(obj){
        return axios
        .post(`${urlBase}/calcularRescisao/${tok}`,obj)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCalcularAdicionalNoturno(mesAno,feriadosMes,salario,jornadaSemanal,adicional,check,horasAdicionalNoturno){     
        return axios
        .post(`${urlBase}/CalcularAdicionalNoturno/${tok}`,{
            "mesAno":mesAno,
            "nFeriados":feriadosMes,
            "salario":salario,
            "jornadaSemanal":jornadaSemanal,
            "adicional":adicional,
            "dsr":check,
            "horasAdicionalNoturno":horasAdicionalNoturno
        })
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getRemuneracao(salarioBruto,mediaVariaveis1,dependentes,gozoFerias,abonoPecuniario,mediaVariaveis2){      
        return axios
        .post(`${urlBase}/CalcularRemuneracaoFerias/${tok}`,{
            "salarioBruto" : salarioBruto,
            "mediaVariavel" : mediaVariaveis1,
            "dependentes" : dependentes,
            "gozoFerias" : gozoFerias,
            "abonoPecuniario" : abonoPecuniario,
            "adiantar13" : mediaVariaveis2
        })
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getFaltasAfastamento(dataInicio,dataFim,faltas,lista){      
        console.log(dataInicio)
        console.log(dataFim)
        console.log(faltas)
        console.log(lista)
        return axios
        .post(`${urlBase}/CalcularFeriasFaltasAfastamento/${tok}`,{
            "dataInico":dataInicio,
            "dataFim":dataFim,
            "faltas":faltas,
            "lista":lista
        })
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getCalcularSeguroDesemprego(faixa1_limite,faixa2_inicio,faixa2_fim,parcela_adicional,parcela_fixa_maxima,valor){
        return axios
        .post(`${urlBase}/seguro-desemprego/${tok}`,{
            "faixa1_limite":faixa1_limite,
            "faixa2_inicio":faixa2_inicio,
            "faixa2_fim":faixa2_fim,
            "parcela_adicional":parcela_adicional,
            "parcela_fixa_maxima":parcela_fixa_maxima,
            "valor":valor
        })
        .then(res=> res.data)
        .catch(err=> console.log(err))
    }

}
//www.lefisc.com.br/api/CalculosTrabalhistas/calculos/CalcularRemuneracaoFerias/a5ec945de42672e03b563faa32f01a90
//www.lefisc.com.br/api/CalculosTrabalhistas/calculos/CalcularAdicionalNoturno/a5ec945de42672e03b563faa32f01a90
//www.lefisc.com.br/api/CalculosTrabalhistas/calculos/seguro-desemprego/a5ec945de42672e03b563faa32f01a90


// WEBPACK FOOTER //
// ./src/services/services.js